/*!
 * vue-activity-indicator v1.1.0
 * (c) 2020 Matúš Duchoň
 * Released under the MIT License.
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.VueActivityIndicator = global.VueActivityIndicator || {})));
}(this, (function (exports) { 'use strict';

(function(){ if(typeof document !== 'undefined'){ var head=document.head||document.getElementsByTagName('head')[0], style=document.createElement('style'), css=" .activity-indicator[data-v-30128117] { display: inline-block; vertical-align: middle; } .activity-indicator--icon[data-v-30128117] { animation: loading-icon__animation .65s infinite linear; transform-origin: 50% 50%; } @keyframes loading-icon__animation { 0% {transform: rotate(0deg);} 100% {transform: rotate(360deg);} } "; style.type='text/css'; if (style.styleSheet){ style.styleSheet.cssText = css; } else { style.appendChild(document.createTextNode(css)); } head.appendChild(style); } })();









var namedSizes = {
  small: { size: 16, stroke: 3 },
  normal: { size: 24, stroke: 3.5 },
  large: { size: 48, stroke: 5 }
};

var ActivityIndicator = {render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"activity-indicator",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":("0 0 " + (_vm.realSize) + " " + (_vm.realSize)),"width":_vm.realSize,"height":_vm.realSize}},[_c('g',{staticClass:"activity-indicator--icon",attrs:{"fill":"transparent"}},[_c('circle',{attrs:{"cx":_vm.radius,"cy":_vm.radius,"r":_vm.radius - _vm.halfStroke,"stroke-width":_vm.realStroke,"stroke":_vm.color,"opacity":_vm.opacity * .35}}),_vm._v(" "),_c('path',{attrs:{"d":("M " + (_vm.halfStroke) + " " + (_vm.radius) + " Q " + (_vm.halfStroke * 1.5) + " " + (_vm.halfStroke * 1.5) + " " + (_vm.radius) + " " + (_vm.halfStroke)),"stroke-width":_vm.realStroke,"stroke":_vm.color,"opacity":_vm.opacity}})])])},staticRenderFns: [],_scopeId: 'data-v-30128117',
  props: {
    size: {
      type: [Number, String],
      default: 'normal'
    },

    color: {
      type: String,
      default: 'black'
    },

    stroke: {
      type: Number
    },

    opacity: {
      type: Number,
      default: 0.35
    }
  },

  computed: {
    realSize: function realSize() {
      return (namedSizes[this.size] && namedSizes[this.size].size) || this.size
    },

    realStroke: function realStroke() {
      return this.stroke || (namedSizes[this.size] && namedSizes[this.size].stroke) || this.realSize / 10
    },

    halfStroke: function halfStroke() {
      return this.realStroke / 2
    },

    radius: function radius() {
      return this.realSize / 2
    }
  }
};

var plugin = {
  install: function install (Vue, options) {
    Vue.component('activity-indicator', ActivityIndicator);
  }
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports['default'] = plugin;

Object.defineProperty(exports, '__esModule', { value: true });

})));
